// import logo from './logo.svg';
import './App.scss';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import Jobs from './components/jobs/Jobs';


function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <div className="content">
        <div className="content__about">
          <h1>Du möchtest wissen, wer wir sind und was wir machen?</h1>
          <p>Wir sind ein junges Unternehmen mit Büro in Hof und über 50 Mitarbeiter:innen, verteilt in ganz Deutschland. Seit unserer Gründung im Jahr 2016 betreiben wir einen Online-Marktplatz für “Skins” aus dem Game Counter-Strike. „Skins“ sind digitale Güter. Diese können bei uns erworben und InGame verwendet werden. Unseren 2 Millionen registrierten Nutzern bieten wir damit eine Plattform zum sicheren Kauf, Verkauf und Handel von Skins. Durch unsere Wurzeln im E-Sport und Gaming sind wir im engen Kontakt zu unseren Kunden, aber auch zu Pro's. Das ermöglicht es uns stetig neue kreative Features auf die Wünsche unserer Kunden und anzupassen, wie zum Beispiel unseren  3D-Viewer. Jedoch arbeiten wir nicht nur am Thema "Skins", sondern auch an Themen wie Gaming Hardware und Retro-Spiele.</p>
        </div>
        <Jobs />
        <div className="contact">
          <div className="contact__content">
            <h3>Bist du interessiert?</h3>
            <span>Der Baron freut sich auf Deine Bewerbung!</span>
            <p></p>
            <span>Alle unsere Stellen sind sowohl in Vollzeit<br />als auch in Teilzeit zu besetzen.</span>
          </div>
          <div className="contact__content">
            <h3>Ansprechpartner:</h3>
            <span>Phung, Phuong Duc (he/him)<br />Ossecker Straße 165, 95030 Hof</span>
          </div>
          <div className="contact__content">
            <h3>E-Mail:</h3>
            <a
            href="mailto:bewerbung@skinbaron.de"
            target="_blank"
            rel="noopener noreferrer">bewerbung@skinbaron.de</a>
          </div>
        </div>
        <div className="footer">
          <span>© {(new Date().getFullYear())} SkinBaron GmbH</span>
          <a className="imprint"
          target="_blank"
          href="/de/imprint"
          rel="noopener noreferrer">Impressum</a>
        </div>
      </div>
    </div>
  );
}

export default App;
